/**

  Authors: Toni Ruottu, Finland 2010-2019

  This file is part of Dark WebSocket Terminal.

  CC0 1.0 Universal, http://creativecommons.org/publicdomain/zero/1.0/

  To the extent possible under law, Dark WebSocket Terminal developers have waived all
  copyright and related or neighboring rights to Dark WebSocket Terminal.

*/

export default class Help {
  constructor(dwst) {
    this._dwst = dwst;
  }

  commands() {
    return ['help'];
  }

  usage() {
    return ['/help', '/help <command>'];
  }

  examples() {
    return ['/help', '/help send', '/help binary'];
  }

  info() {
    return 'get help';
  }

  _run(section = '#help') {
    this._dwst.ui.terminal.clearLog();
    const page = this._dwst.model.help.page(section);
    this._dwst.ui.terminal.mlog(page, 'system');
  }

  run(paramString) {
    if (paramString.length < 1) {
      this._run();
      return;
    }
    const params = paramString.split(' ');
    this._run(...params);
  }
}
